import { createFileRoute } from '@tanstack/react-router'
import { TasksView } from '@/components/tasks/tasks-view'

export const Route = createFileRoute('/(app)/productivity/tasks/')({
  component: TasksView,
})
